import { Injectable } from '@angular/core';

import { SessionService } from './session.service';

import { ClientUserData, ProfessionalUserData } from '@shared/models/auth.interface';

import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class UserInfoService {
  private _userInfo: ClientUserData | undefined;

  constructor(private sessionService: SessionService, private popup: MatDialog,) { }

  getClientInfo(): ClientUserData | null {
    try {
      if (this._userInfo) return this._userInfo;

      // if user info is not set yet.
      const jtiFound = this.sessionService.getJTIFromCurrentRoute();
      if (jtiFound) {
        const userDataAsString = this.sessionService.getDecryptedStorageValue(`data:${jtiFound}`);
        let storeData = JSON.parse(userDataAsString);
        if (storeData.userIsClient === true) {
          return storeData.userData;
        }
      }
    }
    catch
    {
    }

    return null;
  }

  getProfessionalInfo(): ProfessionalUserData | null {
    try {
      // if (this._userInfo) return this._userInfo;

      // if user info is not set yet.
      const jtiFound = this.sessionService.getJTIFromCurrentRoute();
      if (jtiFound) {
        const userDataAsString = this.sessionService.getDecryptedStorageValue(`data:${jtiFound}`);
        let storeData = JSON.parse(userDataAsString);
        if (storeData.userIsClient === false) {
          return storeData.userData;
        }
      }
    }
    catch
    {
    }

    return null;
  }

  isUserTypeClient(): boolean | null {
    try {
      const jtiFound = this.sessionService.getJTIFromCurrentRoute();
      if (jtiFound) {
        const userDataAsString = this.sessionService.getDecryptedStorageValue(`data:${jtiFound}`);
        let storeData = JSON.parse(userDataAsString);
        return storeData.userIsClient;
      }
    }
    catch
    {
    }

    return null;
  }

  logoutUser() {
    this.popup.closeAll();
    const jtiFound = this.sessionService.getJTIFromCurrentRoute();
    if (jtiFound) {
      this.sessionService.removeMappingFor(jtiFound);
    }
  }
}
